var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2173 7.93749L11.229 4.94916C10.9945 4.71478 10.6765 4.58314 10.345 4.58322C10.0134 4.5833 9.69547 4.71508 9.46109 4.94958C9.2267 5.18407 9.09507 5.50207 9.09515 5.83362C9.09523 6.16517 9.22701 6.48311 9.4615 6.71749L11.494 8.74999H4.1665C3.83498 8.74999 3.51704 8.88169 3.28262 9.11611C3.0482 9.35053 2.9165 9.66847 2.9165 9.99999C2.9165 10.3315 3.0482 10.6495 3.28262 10.8839C3.51704 11.1183 3.83498 11.25 4.1665 11.25H11.494L9.4615 13.2825C9.22701 13.5169 9.09523 13.8348 9.09515 14.1664C9.09507 14.4979 9.2267 14.8159 9.46109 15.0504C9.69547 15.2849 10.0134 15.4167 10.345 15.4168C10.6765 15.4168 10.9945 15.2852 11.229 15.0508L14.2173 12.0625C14.7634 11.515 15.07 10.7733 15.07 9.99999C15.07 9.22673 14.7634 8.48502 14.2173 7.93749Z",
    fill: "#CB90FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageArrow);
export default __webpack_public_path__ + "static/media/MessageArrow.79120a2993eaecf99400aba183a505eb.svg";
export { ForwardRef as ReactComponent };